/**
 * Returns the value of a query string paramter of the current url if exists, undefined otherwise.
 * @param key The name of the parameter
 * @returns The value or undefined
 */
export function getQueryStringValue(key: string, searchInHash: boolean = false): string {
  let result = undefined;
  const locationSection = searchInHash ? window.location.hash : window.location.search;

  if (locationSection && locationSection.length > 1) {
    const keyValues = locationSection.substring(1).split('&');
    let i = 0;
    while (result === undefined && i < keyValues.length) {
      let split = keyValues[i].split('=');
      if (split.length === 2 && split[0] === key) result = split[1];
      i++;
    }
  }

  return result;
}

export function addMinutes(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

/**
 * Decodes a JWT token
 * @param token The JWT token
 * @returns The decoded token
 */
export function decodeToken(token: string): any {
  if (!token) return undefined;
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch (e) {
    return undefined;
  }
}
